import { useState, useEffect, useRef } from "react";
import $api from "@/zapi-frontend/shared/api/axios";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";

type TVersionInfo = {
    hash: string;
    branch: string;
    hasUncommittedChanges: boolean;
};

// TODO: Probably needs refactoring but it was done in a rush
export function useSnippetsVersionInfo() {
  const [versionInfo, setVersionInfo] = useState<TVersionInfo | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { customSnippetsUrl, isLabs } = useMeStore();
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!isLabs || hasFetchedRef.current) {
      return;
    }
    hasFetchedRef.current = true;

    const fetchVersionInfo = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        const response = await $api.get<TVersionInfo>("/auth/latest-commit");
        setVersionInfo(response.data);
      } catch (err) {
        console.error("Failed to fetch version info:", err);
        setError("Failed to fetch version info");
      } finally {
        setIsLoading(false);
      }
    };

    fetchVersionInfo();
  }, [customSnippetsUrl, isLabs]);

  const getDisplayText = () => {
    if (!versionInfo) return null;
    
    const shortHash = versionInfo.hash.slice(0, 6);
    return `${shortHash}/${versionInfo.branch}` + (versionInfo.hasUncommittedChanges ? " (+uncommitted changes)" : "");
  };

  return {
    versionInfo,
    isLoading,
    error,
    displayText: getDisplayText()
  };
}
